
import { Component, Emit, Prop, mixins } from 'nuxt-property-decorator'
import { Debounce } from 'vue-debounce-decorator'
import { exist } from '@/utils/exist'
import KeyboardEventsMixin from '~/utils/mixins/keyboardEventsMixin'
import { usePreferencesStore } from '@/stores/preferences'
import { NeoField, NeoInput } from '@kodadot1/brick'

@Component({
  components: {
    Sort: () => import('./SearchSortDropdown.vue'),
    BasicSwitch: () => import('@/components/shared/form/BasicSwitch.vue'),
    NeoField,
    NeoInput,
  },
})
export default class SearchCollection extends mixins(KeyboardEventsMixin) {
  @Prop(String) public search!: string
  @Prop(String) public type!: string
  @Prop({ type: String, default: 'blockNumber_DESC' }) public sortBy!: string
  @Prop({ type: Boolean, default: false }) public listed!: boolean
  @Prop({ type: Boolean, default: false }) public owned!: boolean
  @Prop(Boolean) public disableToggle!: boolean
  @Prop(Boolean) public hideSearch!: boolean
  @Prop(Boolean) public isMoonRiver!: boolean
  @Prop(Boolean) public showOwnerSwitch!: boolean
  @Prop(Array) public sortOption?: string[]
  protected isVisible = false
  private preferencesStore = usePreferencesStore()

  public mounted(): void {
    exist(this.$route.query.search, this.updateSearch)
    exist(this.$route.query.type, this.updateType)
    exist(this.$route.query.sort, this.updateSortBy)
    exist(this.$route.query.listed, this.updateListed)
    exist(this.$route.query.owned, this.updateOwned)
  }

  public created() {
    this.initKeyboardEventHandler({
      f: this.bindFilterEvents,
    })
  }

  private bindFilterEvents(event) {
    switch (event.key) {
      case 'b':
        this.updateListed(!this.vListed)
        break
      case 'n':
        this.updateSortBy(this.sortOption?.[0] || '')
        break
      case 'o':
        this.updateSortBy(this.sortOption?.[1] || '')
        break
      case 'a':
        this.updateSortBy(this.sortOption?.[2] || '')
        break
      case 'e':
        this.updateSortBy(this.sortOption?.[3] || '')
        break
    }
  }

  get vListed(): boolean {
    return this.listed
  }

  set vListed(listed: boolean) {
    this.updateListed(listed)
  }

  get vOwned(): boolean {
    return this.owned
  }

  set vOwned(owned: boolean) {
    this.updateOwned(owned)
  }

  get searchQuery(): string {
    return this.search
  }

  set searchQuery(value: string) {
    this.updateSearch(value)
  }

  get typeQuery(): string {
    return this.type
  }

  set typeQuery(value: string) {
    this.updateType(value)
  }

  get replaceBuyNowWithYolo(): boolean {
    return this.preferencesStore.getReplaceBuyNowWithYolo
  }

  @Emit('update:listed')
  @Debounce(50)
  updateListed(value: string | boolean): boolean {
    const queryValue = String(value) === 'true'
    this.replaceUrl(queryValue, 'listed')
    return queryValue
  }

  @Emit('update:owned')
  @Debounce(50)
  updateOwned(value: string | boolean): boolean {
    const queryValue = value ? String(value) : ''
    this.replaceUrl(queryValue, 'owned')
    return Boolean(queryValue)
  }

  @Emit('update:type')
  @Debounce(50)
  updateType(value: string): string {
    this.replaceUrl(value, 'type')
    return value
  }

  @Emit('update:sortBy')
  @Debounce(400)
  updateSortBy(value: string): string {
    const listed = Boolean(value?.toLowerCase().indexOf('price') > -1)
    if (listed && !this.vListed) {
      this.vListed = true
    }

    this.replaceUrl(value, 'sort')
    return value
  }

  @Emit('update:search')
  @Debounce(400)
  updateSearch(value: string): string {
    value !== this.searchQuery && this.replaceUrl(value)
    return value
  }

  @Debounce(100)
  replaceUrl(value: boolean | string, key = 'search'): void {
    this.$router
      .replace({
        path: String(this.$route.path),
        query: {
          ...this.$route.query,
          search: this.searchQuery || undefined,
          [key]: value ? String(value) : undefined,
        },
      })
      .catch(this.$consola.warn /*Navigation Duplicate err fix later */)
  }
}
